<template>
  <div class="full-height q-pa-md">
    <jt-profile-permission
      :id="id"
      :interface="nmInterface"
      :name="name"
      :params="params"
    />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import JtProfilePermission from 'src/components/jt-profile-permission/JtProfilePermission.vue'

@Component({
  name: 'profile-permission',
  components: {
    JtProfilePermission
  },
  props: {
    id: String,
    interface: String,
    name: String,
    params: Object
  }
})
export default class ProfilePermission extends Vue {
  get nmInterface () {
    return this.interface
  }
}
</script>
<style lang="stylus" scoped>
.circle-blue {
  border-radius: 50%;
  display: inline-block;
  height: 12px;
  width: 12px;
  background-color: #7abcce;
  position: relative;
  text-align: center;
}
.circle-orange {
  border-radius: 50%;
  display: inline-block;
  height: 12px;
  width: 12px;
  background-color: orange;
  position: relative;
  text-align: center;
}
.circle-green {
  border-radius: 50%;
  display: inline-block;
  height: 12px;
  width: 12px;
  background-color: #34c447;
  position: relative;
  text-align: center;
}
</style>
